import ChatMessagesContainer from './ChatMessagesContainer';

export default ChatMessagesContainer;
